{
  "ACTIONS": {
    "CONFIRM": "Подтвердить",
    "CONTINUE": "Продолжить",
    "SUBMIT": "Отправить",
    "RETRY": "Повторить",
    "CANCEL": "Отменить",
    "EMPTY": "У Вас нет заказов",
    "LOADING_ORDERS": "Подготовка вашего счёта",
    "CLEAR_ALL": "Очистить все",
    "AWESOME": "потрясающий!",
    "VIEW_RECEIPT": "Квитанция",
    "ADD_CART": "добавить в корзину",
    "UPDATE_CART": "Обновить корзину",
    "EDIT": "Редактировать",
    "SEARCH_PLACEHOLDER": "Поиск еды"
  },
  "COMMON": {
    "CALORIES": "{{calories}} калорий",
    "MISSING_SELECTIONS": "Некоторые параметры отсутствуют. Выберите их, прежде чем продолжить.",
    "ITEM_UNAVAILABLE": "Этот пункт в настоящее время не доступен",
    "SECTION_NOT_FOUND": "Этот раздел больше недоступен",
    "ITEM_NOT_FOUND": "Эта позиция больше недоступна",
    "PROMOTION_NOT_AVAILABLE": "Эта акция больше недоступна",
    "REQUIRED": "Необходимый",
    "COMBO": "Комбо",
    "INVALID_EMAIL": "Пожалуйста, введите действительный адрес электронной почты",
    "INVALID_PHONE": "Пожалуйста, введите действительный номер телефона",
    "FEES": "Сборы",
    "MIN_ORDER_ERROR": "Minimum order value of {{currency}} {{amount}} is required to place your order",
    "ADD_MIN_ORDER": "Добавлять {{currency}} {{amount}} чтобы разместить заказ",
    "CONNECTION_ERROR": "Не удалось загрузить этот стол. Пожалуйста, попробуйте ещё раз.",
    "TABLE_NOT_FOUND": "Мы не нашли этот стол. Пожалуйста, отсканируйте QR-код ещё раз."
  },
  "LANGUAGES": {
    "EN": "English",
    "AR": "عربي",
    "FA": "فارسي",
    "HI": "हिन्दी",
    "RU": "русский",
    "DE": "Deutsch",
    "FR": "Français",
    "TH": "ไทย",
    "EL": "Ελληνικά",
    "CNR": "Crnogorski",
    "ZH-HANS": "中文",
    "RO": "Română",
    "HU": "Magyar",
    "BG": "български",
    "TR": "Türkçe",
    "ES": "Español"
  },
  "BILL": {
    "NAME": "Фамилия",
    "ROOM_NUMBER": "Номер комнаты",
    "SNACKBAR_TITLE": "Ваш счет формируется",
    "PAY_BILL": "Оплатить счет"
  },
  "PAY_AT_TABLE": {
    "TOTAL_PEOPLE": "Всего человек за столом",
    "PAYING_FOR": "Количество человек, за которых вы платите",
    "REMAINING": "Оставшаяся сумма",
    "CHEQUE": "Счёт",
    "AMOUNT_PAID": "Оплаченная сумма",
    "DISCOUNT": "Скидка",
    "PROMO": "Промо",
    "FEES": "Сборы",
    "PAID_ITEMS": "Оплаченные позиции",
    "SPLIT_BILL": "Разделить счёт",
    "EDIT_SPLIT": "Изменить разделение",
    "PAY_BILL": "Оплатить счёт",
    "SPLIT_TITLE": "Разделить счёт",
    "SPLIT_SUBTITLE": "Выберите, как вы хотите разделить счёт",
    "SPLIT_EVENLY": "Разделить поровну",
    "CUSTOM_AMOUNT": "Своя сумма",
    "ADD_CUSTOM_AMOUNT": "Добавить свою сумму",
    "CUSTOM_AMOUNT_PLACEHOLDER": "Введите свою сумму",
    "PAY_FOR_ITEMS": "Оплатите свои позиции",
    "CONFIRM_SELECTION": "Подтвердить выбор",
    "SOMEONE_ELSE_PAYING": "Кто-то за вашим столом сейчас оплачивает счёт"
  },
  "COMBO": {
    "ADD_N": "Добавить {{count}} {{section}}",
    "REMOVE_N": "Убрать {{count}} {{section}}",
    "CANNOT_PROCEED": "Пожалуйста, следуйте инструкции выше, чтобы завершить комбо, прежде чем продолжить",
    "COMPLETE": "Комбо «{{combo}}» готово!",
    "ON_ANOTHER_SECTION": "Это часть вашего комбо «{{section}}»"
  },
  "CART": {
    "TITLE": "Корзина",
    "RECOMMENDATION": "Вам также может понравиться",
    "TOTAL": "Всего",
    "VIEW": "Просмотреть корзину",
    "EMPTY": "Пусто",
    "PLACE_ORDER": "Разместить заказ",
    "ADD_TO_BILL": "Добавить в счёт",
    "PAY_NOW": "Оплатить сейчас",
    "OOPS": "Ой",
    "ADD_NEW_VARIANT": "Добавить ещё",
    "VARIANT_TITLE": "Передумали?",
    "ITEM_UPDATED": "An item in your cart has been updated",
    "ITEM_REMOVED": "An item was removed from your cart because it's no longer available",
    "ITEM_LINE": "{{name}}",
    "CONFIRM_CLEAR": "Вы уверены, что хотите очистить корзину?",
    "CLEAR": "Очистить корзину",
    "ADD_NOTE": "Добавить примечание",
    "NOTE_LABEL": "Примечание"
  },
  "PAYMENT": {
    "CONFIRMED": "Ваш заказ был оплачен!",
    "ERROR": "При оплате произошла ошибка, пожалуйста, попробуйте еще раз",
    "APPLE_PAY_TAP_AGAIN": "Пожалуйста, нажмите Apple Pay ещё раз, чтобы продолжить",
    "TITLE": "Оплата",
    "PAY_CARD": "Касса",
    "SUCCESSFUL": "Платеж прошел успешно",
    "SUMMARY": "Сводка платежей",
    "PROGRESS": "Платеж в процессе..., пожалуйста, подождите",
    "CANCEL": "Пожалуйста, не обновляйте эту страницу"
  },
  "ORDER": {
    "TITLE": "Мои заказы",
    "CONFIRMED": "Подтвержденные",
    "NOTES": "Примечания к заказу",
    "TOTAL": "Всего",
    "SUBTOTAL": "Промежуточный итог",
    "ORDER": "Заказ",
    "PAID": "Оплаченный",
    "PLACED": "Ваш заказ был размещен",
    "UNPAID": "Ваш заказ не оплачен",
    "CANCELLED": "Ваш заказ отменён",
    "VOID": "Ваш заказ аннулирован",
    "UPDATED": "Ваш заказ обновлён",
    "ORDERS": "Заказы",
    "PREVIOUS": "Предыдущие заказы",
    "REJECTED": "Товары в данный момент недоступны"
  },
  "WAITER": {
    "SNACKBAR_TITLE": "Мы скоро придем",
    "HELP": "Чем мы можем помочь?",
    "ADDITIONAL_COMMENTS": "Комментарии"
  },
  "MENU": {
    "SKIP": "Пропустить",
    "MENU": "Меню",
    "SEARCH": "Поиск",
    "NO_SEARCH_RESULTS": "Нет позиций, соответствующих вашему запросу",
    "SEARCH_OTHER_SECTIONS": "Мы нашли совпадения в других разделах",
    "NO_FILTER_RESULTS": "Нет блюд, соответствующих вашим фильтрам",
    "CLEAR_FILTERS": "Сбросить фильтры",
    "NO_SECTIONS": "Нет доступных разделов",
    "STAFF": "Вызов персонала",
    "FILTERS": "Фильтры питания"
  },
  "SETTINGS": {
    "TITLE": "Настройки",
    "LANGUAGE": "Язык",
    "SELECT_LANGUAGE": "Выберите язык",
    "CURRENCY": "Валюта"
  },
  "HOTEL_PREFERENCE": {
    "ROOM": "В номер"
  },
  "RESCAN": {
    "TITLE": "QR",
    "ACTION": "Пожалуйста, повторно отсканируйте QR, чтобы продолжить сеанс",
    "SESSION_EXPIRED": "Ваш сеанс истёк"
  },
  "PICKUP": {
    "TITLE": "Ваши данные"
  },
  "VOUCHER": {
    "ADD": "Добавить ваучер",
    "PLACEHOLDER": "Введите ваш ваучер",
    "VOUCHER": "Ваучер",
    "DISCOUNTED_AMOUNT": "Итого после скидки",
    "CURRENT_BALANCE": "Баланс",
    "REMAINING_BALANCE": "Баланс после покупки",
    "AMOUNT_DUE": "Сумма долга"
  },
  "TIP": {
    "TIP": "Чаевые",
    "ADD": "Добавить чаевые",
    "PLACEHOLDER": "Введите сумму чаевых"
  },
  "LANDING": {
    "CALL_WAITER": "Позвать официанта",
    "VIEW_BILL": "Посмотреть счёт - ",
    "LOADING_BILL": "Загрузка счёта"
  },
  "LOADER": {
    "Heading": "Обработка платежа...",
    "Subheading": "Пожалуйста, не закрывайте эту страницу. Мы подтверждаем ваш платёж и автоматически перенаправим вас.",
    "Hint": "Обычно это занимает несколько секунд."
  },
  "NoVoucher": "Ваучер недоступен",
  "VoucherDisabled": "Этот ваучер отключён",
  "VoucherExpired": "Этот ваучер просрочен",
  "VoucherAlreadyUsed": "Этот ваучер уже был использован",
  "VoucherZeroBalance": "Баланс этого ваучера равен 0",
  "VoucherUserLimitReached": "Вы уже использовали этот ваучер",
  "VoucherFirstOrderOnly": "Этот ваучер действует только для вашего первого заказа",
  "VoucherNotApplicable": "Этот ваучер не применим к товарам в вашем заказе"
}
